import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useSelector } from 'react-redux';
import services from 'services';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const DownloadJies = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const t = utils.intl.useTranslator();
  const idUser = useSelector(selectors.user.getIdUser) || -1;
  const { checkDocuments } = useCheckBeforeAction(actionType.DOWNLOAD_JIES);
  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    try {
      const { data } = await services.downloadLucyStarter(idUser);
      utils.file.downloadFileFromBase64Source(t('lucy_starter'), data, 'application/zip', 'zip');
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <CommonButton
      id="download-jies-btn"
      action={onClick}
      scope="tertiary"
      value={t('download_jies')}
      disabled={!utils.user.isActionEnabled(records, actionType.DOWNLOAD_JIES)}
      customIcon="download"
    />
  );
};

export default DownloadJies;
